import * as urls from "../../api/C4S Decommission - Replacement/url";
import { getRequest } from "../../../services/RestServices";

export const returnReshipList = async ({ providerOrder }) => {
  try {
    return await getRequest(urls.RETURN_RESHIP_LIST + `?providerOrder=${providerOrder}`);
  } catch (err) {
    return err;
  }
};
